import { render, staticRenderFns } from "./MarketOnePage.vue?vue&type=template&id=172e57aa&scoped=true&"
import script from "./MarketOnePage.vue?vue&type=script&lang=js&"
export * from "./MarketOnePage.vue?vue&type=script&lang=js&"
import style0 from "./MarketOnePage.vue?vue&type=style&index=0&id=172e57aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172e57aa",
  null
  
)

export default component.exports